/* 100X Equine cart page enhancement.

   The page works with zero JavaScript: every control is a real form control posting to
   Shopify's cart routes, and a no-JS "Update cart" button is rendered inside <noscript>.
   This file only UPGRADES that: quantity changes apply instantly against /cart/change.js
   instead of requiring a round trip through a submit button, and remove links stop being
   navigations.

   Deliberately does not re-render the lines from a template. The server already rendered
   them correctly; duplicating that markup here would give two sources of truth for the
   same row, which is exactly how a cart page and its drawer drift apart. Instead the
   affected row is updated in place and removed rows are removed. */
(function () {
  var sec = document.querySelector('[data-gx-cartpage]');
  if (!sec) return;
  var form = sec.querySelector('[data-gx-cp-form]');
  if (!form) return;

  var totalEl = sec.querySelector('[data-gx-cp-total]');
  var busy = false;

  function money(cents) {
    var s = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }

  // Selector and format both mirror gutx-cart.js exactly. If these two ever disagree the
  // nav count changes depending on whether you used the drawer or this page.
  function setNavCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
  }

  function post(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Shopify renumbers lines when one is removed, so a stale `line` index would hit the
  // wrong row. Key is stable for the life of the line, so always change by key.
  function apply(row, qty) {
    if (busy) return;
    busy = true;
    sec.setAttribute('data-gx-busy', '1');
    post({ id: row.getAttribute('data-key'), quantity: qty })
      .then(function (cart) {
        var items = cart.items || [];
        var still = items.filter(function (it) { return it.key === row.getAttribute('data-key'); })[0];
        if (!still) {
          row.remove();
        } else {
          var input = row.querySelector('input[name="updates[]"]');
          if (input) input.value = still.quantity;
          var lp = row.querySelector('.gx-cp-lp b');
          if (lp) lp.textContent = money(still.final_line_price);
        }
        if (totalEl) totalEl.textContent = money(cart.total_price);
        setNavCount(cart.item_count || 0);
        if (!items.length) window.location.reload();   // fall through to the empty state
      })
      .catch(function () { window.location.reload(); })   // never leave the page lying
      .then(function () {
        busy = false;
        sec.removeAttribute('data-gx-busy');
      });
  }

  form.addEventListener('click', function (e) {
    var row = e.target.closest('.gx-cp-line');
    if (!row) return;
    var input = row.querySelector('input[name="updates[]"]');
    var qty = Number(input && input.value) || 0;

    if (e.target.closest('[data-gx-cp-inc]')) { e.preventDefault(); apply(row, qty + 1); }
    else if (e.target.closest('[data-gx-cp-dec]')) { e.preventDefault(); apply(row, Math.max(0, qty - 1)); }
    else if (e.target.closest('[data-gx-cp-rm]')) { e.preventDefault(); apply(row, 0); }
  });

  form.addEventListener('change', function (e) {
    if (!e.target.matches('input[name="updates[]"]')) return;
    var row = e.target.closest('.gx-cp-line');
    if (!row) return;
    apply(row, Math.max(0, Number(e.target.value) || 0));
  });

  // Enter in a quantity box should apply that quantity, not submit and reload the page.
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('input[name="updates[]"]')) {
      e.preventDefault();
      e.target.blur();
    }
  });
})();
